
import { cn } from "@/lib/utils";

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-background/80 backdrop-blur-sm z-50 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-end gap-0.5">
            <img 
              src="/lovable-uploads/df4f4da1-103d-47a3-ba54-1571e4290474.png" 
              alt="V Logo" 
              className="h-8 sm:h-7 lg:h-6 mb-1"
            />
            <span className="text-lg sm:text-xl lg:text-lg font-medium text-foreground font-poppins">Translate</span>
          </div>
          <div className="flex items-center">
            <a 
              href="https://apps.apple.com/app/id1641482851" 
              target="_blank" 
              rel="noopener noreferrer"
              className="h-6 sm:h-8"
            >
              <img 
                src="/lovable-uploads/d8b93309-88aa-4b42-95f8-322df54db561.png"
                alt="Download on the App Store" 
                className="h-full"
              />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
